import styled from 'styled-components'

export const StyledContainer = styled.div`
  &.no-label {
    margin-top: -20px;

    p[class^='StyledLabelText'] {
      display: none;
    }
  }

  textarea {
    min-height: 130px;
  }

  &.small {
    textarea {
      min-height: 40px;
    }
  }
`
